<!-- Estado: Cargando -->
<div *ngIf="isLoading" class="eligibility-message eligibility-message--loading">
  <div class="eligibility-message__shimmer">
    <div class="shimmer shimmer--description"></div>
  </div>
</div>

<!-- Estado: Mensaje cargado -->
<div *ngIf="!isLoading && message" 
     class="eligibility-message"
     [class.eligibility-message--error]="hasError">
  
  <div class="eligibility-message__group">
    <img class="eligibility-message__icon" 
         src="assets/images/Alert-icon.svg" 
         alt="infoIcon">
    <p class="eligibility-message__text">
      {{ message.description }}
    </p>
  </div>
  
</div>

